import React, { useEffect, useRef, useState } from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import { Box, Flex, Text } from "@chakra-ui/react";
import { Divider } from "antd";

// let Score = [
//   0.8,
//   0.8,
//   0.8,
//   0.8,
//   0.2,
//   0.2,
//   0.2,
//   0.8,
//   0.8,
//   0.5,
//   0.5,
//   0.5,
//   0.8,
//   0.8,
//   0.8,
//   0.8,
//   0.2,
//   0.2,
//   0.2,
//   0.8,
//   0.8,
//   0.5,
//   0.5,
//   0.5,
// ];
let Score = [];
let time = [];

const options = {
  chart: {
    type: "spline",
    events: {
      load: function() {
        // set up the updating of the chart each second
        var series = this.series[0];
        let i = 0;
        const line = setInterval(function() {
          const x = new Date().getTime(), // current time
            y = Score[Score.length - 1];
          // y = Score[i++]; // testing
          series.addPoint([x, y], true, true);
        }, 1000);
      }
    }
  },

  xAxis: {
    type: "datetime",
    visible: false,
    categories: time,
    lineWidth: 0,
    labels: {
      step: 10,
      format: "{text} s"
    }
  },
  yAxis: {
    visible: true,
    max: 1,
    min: 0,
    opposite: true,
    gridLineWidth: 0.8,
    tickAmount: 3,
    // tickInterval: 0.05,
    gridLineDashStyle: "longdash",
    title: {
      text: ""
    },
    tickPositioner: function() {
      return [0.2, 0.5, 0.8];
    },
    labels: {
      enabled: true,
      style: {
        fontSize: 12
      },
      formatter: function() {
        console.log("DEBUGGER FORMATTER: ", this.value, this.pos);
        // if (this.value >= 0.7) {
        //   return "VERIFIED";
        // } else if (this.value >= 0.55 && this.value < 0.7) {
        //   return "NOT SURE";
        // } else if (this.value < 0.55) {
        //   return "SOMEONE ELSE";
        // }
        if (this.value == 0.8) {
          return "VERIFIED";
        } else if (this.value == 0.5) {
          return "NOT SURE";
        } else if (this.value == 0.2) {
          return "SOMEONE ELSE";
        }
      }
    }
  },
  credits: {
    enabled: false
  },
  tooltip: {
    enabled: false
  },
  legend: {
    enabled: false
  },
  plotOptions: {
    series: {
      shadow: true,
      lineWidth: 2,
      animation: {
        duration: 6000
      },
      marker: {
        enabled: false,
        states: {
          hover: {
            enabled: false
          }
        }
      }
    }
  },

  accessibility: {
    enabled: false
  },

  time: {
    useUTC: false
  },

  title: {
    text: " "
  },

  exporting: {
    enabled: false
  },

  series: [
    {
      data: (function() {
        // generate an array of random data
        var data = [],
          time = new Date().getTime(),
          i;

        for (i = -5; i <= 0; i += 1) {
          data.push({
            x: time + i * 1000,
            y: 0.5 // not sure
          });
        }
        return data;
      })(),
      zones: [
        {
          value: 0.1,
          color: "#ff0000"
        },
        {
          value: 0.2,
          color: "#dc0808"
        },
        {
          value: 0.3,
          color: "#c70a0a"
        },
        {
          value: 0.4,
          color: "#ae0909"
        },
        {
          value: 0.5,
          color: "#ae0909"
        },
        {
          value: 0.55,
          color: "#0a3f8b"
        },
        {
          value: 0.7,
          color: "#31d108"
        },
        {
          value: 0.8,
          color: "#09a10d"
        },
        {
          value: 0.9,
          color: "#07700a"
        },
        {
          value: 1,
          color: "#065a08"
        }
      ]
    }
  ]
};

const Chart = ({ data, endCall }) => {
  const chartComponentRef = useRef(null);

  useEffect(() => {
    Score = [];
    time = [];
    data.map(data => {
      Score.push(parseFloat(data.score));
    });

    console.log("DEBUG: Score ", Score);
  }, [Score, time, endCall]);

  return (
    <Flex>
      <Box w="100%">
        {/* <Text>Score: {Score[Score.length - 1]}</Text> */}
        <HighchartsReact
          ref={chartComponentRef}
          highcharts={Highcharts}
          options={options}
          borderColor="#A0A8B9"
          opacity="0.25"
        />
      </Box>
    </Flex>
  );
};

export default Chart;
